import { Input } from "./Field";
import {
  formatPhoneDisplay,
  isPhoneComplete,
  normalizePhoneRu,
  parseNationalDigits,
} from "../../utils/phoneMask";

/**
 * Поле телефона с маской +7 (XXX) XXX-XX-XX.
 * value / onChange работают с форматом +7XXXXXXXXXX.
 */
export default function PhoneInput({
  value,
  onChange,
  onBlur,
  placeholder = "+7 (___) ___-__-__",
  ...rest
}) {
  const display = formatPhoneDisplay(value);

  const handleChange = (e) => {
    const raw = e.target.value;
    if (!raw.replace(/\D/g, "")) {
      onChange?.("");
      return;
    }
    const normalized = normalizePhoneRu(raw);
    onChange?.(normalized);
  };

  const handleBlur = (e) => {
    const national = parseNationalDigits(value);
    if (national && !isPhoneComplete(value)) {
      onChange?.("");
    }
    onBlur?.(e);
  };

  return (
    <Input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder}
      value={display}
      onChange={handleChange}
      onBlur={handleBlur}
      {...rest}
    />
  );
}
